import React from "react";
import { useImperativeHandle } from "react";

import { useTranslation } from 'react-i18next';

const BeamBeamConnectorPositionPicker = ({}, ref) => {
  const { t } = useTranslation();
  const [selectValue, setSelectValue] = React.useState(2);
  const onChange = (event) => {
    const value = event.target.value;
    setSelectValue(value);
    console.log(event.target.value);
  };
  useImperativeHandle(ref, () => ({
    getData: getData,
  }));
  const getData = () => {
    return selectValue;
  };
  return (
    <div class="form-col1_6">
      <label class="form-label" for="grid-ConnectorPosition">
        {t('ConnectorPositionCut')}
      </label>
      <select class="form-select" id="grid-ConnectorPosition" name="grid-ConnectorPosition" onChange={onChange} defaultValue={selectValue}>
        <option value={2}>Bordo superiore</option>
        <option value={3}>Centro piano di taglio</option>
      </select>
    </div>
  );
};

export default React.forwardRef(BeamBeamConnectorPositionPicker);
